module.exports = __webpack_public_path__ + "img/39.like.bcbfdb1e.svg";